module.exports = __webpack_public_path__ + "static/media/Aaron.3d1e3d2d.mp3";